<template>
<section class='mt-2'>
  <b-alert :show="isInfoRma" variant=warning>
    <b-row>
      <b-col>
        This return appears to have been done through info!<br/>
        <span v-if=returnRefunded>
          It has been marked refunded - nothing more to do here
        </span>
        <span v-else>
          It will not be refunded automatically, and the customer will not be informed when the items are recieved!
        </span>
      </b-col>
    </b-row>
    <b-row v-if="!returnRefunded">
      <b-col align=right v-if="returnsAccess">
        <i class="fas fa-fw fa-user-lock"></i>
        Click here if you have refunded this manually, it will remove this message for everyone:
        <b-btn @click=refundReturn>I have refunded this return</b-btn>
      </b-col>
      <b-col align=right v-else>
        Marking Refunds as issued is restricted. If you believe you should have access to this functionality, ask IT for access!
      </b-col>
    </b-row>
  </b-alert>
</section>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT

export default {
  props: {
    order: { type: Object, required: true },
  },
  data() {
    return {
      returnRefunded: false,
    };
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/returns/refunded/${this.$route.params.id}`).then( r => {
      this.returnRefunded = r.data;
    })
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
    }),
    returnsAccess() {
      return this.$store.getters.canAccess('returns-info-access')
    },
    isInfoRma() {
      return this.order.num[0] == 'R' &&
             this.order.sources[0] == 'fishbowl' &&
             this.order.sources.length === 1
    },
  },
  methods: {
    refundReturn() {
      if (!this.returnsAccess) return;

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/returns/refunded/${this.$route.params.id}`,
        data: { },
      }).then(() => {
        window.location.reload()
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/RmaRefundBanner.vue